import React, { useMemo } from "react";
import { formatDate, weekOfTheYear } from "../../utils/formatDate";
import { formatPriceWs } from "../../utils/formatPrice";
import styles from "./Item.module.scss";
import config from "../../utils/config";
export default function Item(props) {
    const { strings } = props;
    const showEndTime = props.type == ItemType.Active || props.type == ItemType.Completed;
    const imageUrl = useMemo(() => `${config.auctionItemsImagesRootUrl}/img/${props.item.id}/${props.item.mainImageFileId}?size=sm`, [props.item]);
    function showBidPrice() {
        if (props.item.bidsCount === 0 && (!props.item.endAt || new Date(props.item.endAt) < new Date())) {
            return props.strings.noBidsAuctionEnded;
        }
        else {
            return formatPriceWs(props.item.currentBidPrice);
        }
    }
    return (React.createElement("div", { className: styles.item },
        React.createElement("div", { className: styles.title },
            React.createElement("a", { href: props.item.relativeUrl },
                React.createElement("span", null,
                    strings.objectNumberText,
                    ": ",
                    props.item.number))),
        React.createElement("div", { className: styles.title, title: props.item.name },
            React.createElement("a", { href: props.item.relativeUrl },
                React.createElement("span", null, props.item.description))),
        React.createElement("div", { className: styles.thumbnail },
            React.createElement("a", { href: props.item.relativeUrl },
                React.createElement("img", { src: imageUrl, alt: props.item.name }))),
        React.createElement("div", { className: styles.auctionName },
            React.createElement("span", null, props.item.auctionName)),
        React.createElement("div", { className: styles.text }, showEndTime && (React.createElement("span", null,
            strings.auctionEndText,
            ":\u00A0",
            formatDate(props.item.endAt)))),
        (props.type == ItemType.Waiting && props.item.startAt) && (React.createElement("div", { className: styles.text },
            React.createElement("span", null,
                strings.auctionStartText,
                ":\u00A0",
                weekOfTheYear(props.item.startAt)))),
        React.createElement("div", { className: styles.text },
            React.createElement("span", null,
                strings.estimatedPriceText,
                ":\u00A0",
                formatPriceWs(props.item.estimatedPrice))),
        React.createElement("div", { className: styles.text },
            (props.type == ItemType.Active || props.type == ItemType.Waiting) && (React.createElement("span", null,
                strings.currentBidPriceText,
                ":\u00A0",
                React.createElement("span", { className: styles.highlight }, props.item.bidsCount === 0 ? strings.noBidsAuctionEnded : formatPriceWs(props.item.currentBidPrice)))),
            props.type == ItemType.Completed && (React.createElement("strong", null,
                "Tilslag:\u00A0",
                React.createElement("span", { className: styles.highlight }, showBidPrice())))),
        React.createElement("div", { className: styles.bidsCount }, showEndTime && (React.createElement("span", null,
            strings.bidsCountText,
            ":\u00A0",
            React.createElement("span", { className: styles.highlight }, props.item.bidsCount))))));
}
export var ItemType;
(function (ItemType) {
    ItemType[ItemType["Active"] = 1] = "Active";
    ItemType[ItemType["Waiting"] = 0] = "Waiting";
    ItemType[ItemType["Completed"] = 2] = "Completed";
})(ItemType || (ItemType = {}));
